/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import NotableInfo from "reusables/TextFormats/NotableInfo";

// Images

// Reusable Components
import UnNumberedList from "reusables/TextFormats/UnNumberedList";
import Email from "reusables/Contact/Email";

import PropTypes from "prop-types";

function TnC_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;
  const emphasis = (text) => (
    <MKTypography component="span" color="dark">
      {text}{" "}
    </MKTypography>
  );

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title="1. Definitions"
            contents={
              <>
                {emphasis("Company")}– means Spechs Limited and/or any franchisees trading under a
                franchisee agreement.
                <br />
                {emphasis("Personnel")}– means the person or firm carrying out services on behalf of
                The Company.
                <br />
                {emphasis("Client")}– means the person, firm or corporate body together with any
                subsidiary or associated company as defined by the Companies Act 2014 to whom the
                services are supplied by The Company.
                <br />
                {emphasis("Service")}– means the services carried out on behalf of The Company.
                <br />
                {emphasis("Visit")}– means the visit to the Client’s service address by The
                Personnel in order to carry out The Service.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="2. Contract"
            contents={
              <>
                {emphasis("2.1.")}These Terms and Conditions represent a contract between The
                Company and The Client.
                <br />
                {emphasis("2.2.")}The Client agrees that any use of The Service, including The
                Client agrees that any use of The Service, including placing an order for services
                by telephone, email, or website forms shall constitute the Client’s acceptance of
                these Terms and Conditions.
                <br />
                {emphasis("2.3.")}Unless otherwise agreed in writing these Terms and Conditions
                shall prevail over any other terms of business or purchase conditions put forward by
                The Client.
                <br />
                {emphasis("2.4.")}No variation or alteration of these Terms and Conditions shall be
                valid unless approved in writing by a director of The Company.
                <br />
                {emphasis("2.5.")}The Company operates a minimum charge of 2 hours per Visit.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="3. Payment"
            contents={
              <>
                {emphasis("3.1.")}All work carried out by The Company at The Client’s request,
                whether otherwise will be charged accordingly. Any work undertaken by The Company on
                behalf of The Client is carried out on the basis that The Client has fully approved
                such work, whether or not The Company has received an official order, provided there
                is evidence of written or verbal confirmation to proceed, including letters,
                facsimile, or email correspondence.
                <br />
                {emphasis("3.2.")}Payments of fees rendered by invoice are due within the dates
                stated on the invoice via our appointed Bank or other mutually agreed payment
                methods.
                <br />
                {emphasis("3.3.")}Interest and compensation for overdue accounts will be applied in
                accordance with the Late Payment in Commercial Transactions Regulations 2012.
                Interest will be charged at the European Central Bank&apos;s reference rate plus 8%.
                Compensation for debt recovery costs will be as follows: €40 for debts up to €1,000,
                €70 for debts between €1,000.01 and €10,000, and €100 for debts above €10,000. Where
                payment has not been received according to agreed terms, we reserve the right to
                withhold services, documents, and information, cease work on the Client’s account,
                and terminate the engagement if payments are unduly delayed.
                <br />
                {emphasis("3.4.")}Any expenses incurred while working on behalf of The Client will
                be charged, and appropriate records will be kept and available for inspection. Such
                expenses may include, but are not limited to, the use of meeting rooms, internal
                printing, and courier charges.
                <br />
                {emphasis("3.5.")}Consistent late payment will incur a 20% pre-payment for all
                future work.
                <br />
                {emphasis("3.6.")}Unless otherwise expressly stated, all prices shall be in Euro and
                shall be exclusive of VAT and other duties.
                <br />
                {emphasis("3.7.")}We shall invoice monthly or at the end of a project dependent on
                the agreed terms.
                <br />
                {emphasis("3.8.")}All prices are net, and no settlement discount is allowed. All
                accounts are payable no later than 7 (Seven) days from the date of invoice, unless
                otherwise agreed by The Company in writing. Note that the payment terms are required
                whether or not The Client has signed off on the copy.
                <br />
                {emphasis("3.9.")}After the 7-day payment period has passed, all further work for
                The Client will cease.
                <br />
                {emphasis("3.10.")}All quotations offered by The Company are deemed valid for a
                period of 30 (Thirty) days, after which time The Company reserves the right to
                revise the said quotation.
                <br />
                {emphasis("3.11.")}The Company provides The Service on a one-off and retainer basis.
                <br />
                {emphasis("3.12.")}Any additional work requested that is not covered in the original
                brief will be quoted separately and added to the original invoice. One month’s
                notice is required to discontinue The Service.
                <br />
                {emphasis("3.13.")}All service prices are reviewed each year and adjusted inline
                with the Contract Cleaning Rate as per the Employment Regulation Order.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="4. Equipment"
            contents={
              <>
                {emphasis("4.1.")}Cleaning materials and equipment will be provided as agreed in the
                contract, either by The Company or The Client. If The Client requires the use of
                their solutions or equipment, they must ensure these are safe to use, in full
                working order, and do not require any special skills to operate for cleaning
                purposes.
                <br />
                {emphasis("4.2.")}If The Client has equipment that is complex to operate, they must
                provide clear and detailed instructions to The Personnel.
                <br />
                {emphasis("4.3.")}If The Client requires The Personnel to use their own materials
                and equipment, including a vacuum cleaner, The Company cannot accept any liability
                for issues arising with the equipment or the outcome of using it.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="5. Checklists"
            contents={
              <>
                {emphasis("5.1.")}The Company will provide The Client with a checklist upon request
                or request The Client to leave a list of priorities for The Personnel. This allows
                The Personnel to work through the list systematically within the allotted time,
                marking off completed tasks.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="6. Refunds"
            contents={
              <>
                {emphasis("6.1.")}No refunds will be provided once The Service has been completed.
                If The Client is dissatisfied with any aspect of The Service, they must notify The
                Company within 24 hours. In such cases, The Company will offer to rectify the issue
                by providing a re-clean or other appropriate solution.
                <br />
                {emphasis("6.2.")}A refund will be issued only if The Client cancels a cleaning
                visit at least 24 hours prior to the start of the session and payment has already
                been received by The Company.
                <br />
                {emphasis("6.3.")}A refund will be issued if The Personnel fail to attend The Visit
                for which payment has already been received by The Company.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="7. Cancellation"
            contents={
              <>
                {emphasis("7.1.")}The Client agrees to pay the full price of The Visit if:
                <br />
                <MKBox sx={{ pl: 3 }} component="ol" color="text">
                  {emphasis("a)")}The Client cancels or changes the date/time less than 24 hours
                  prior to the scheduled appointment;
                  <br />
                  {emphasis("b)")}The Client fails to provide access to the service premises, thus
                  preventing The Company from carrying out the booked work;
                  <br />
                  {emphasis("c)")}There is an issue with The Client’s keys, and The Personnel cannot
                  gain access. If keys are provided, they must open all locks effortlessly.
                </MKBox>
                {emphasis("7.2.")}If The Client needs to change a service day or time, The Company
                will do its best to accommodate them. A minimum of 24 hours’ notice is required.
                Please note that The Company cannot guarantee that the same Personnel will be
                assigned on the new day and time requested by The Client. All schedule changes are
                subject to availability.
                <br />
                {emphasis("7.3.")}The Company’s Personnel are available to work on any day of the
                week, including Bank Holidays. If The Visit is scheduled on a Bank Holiday and The
                Client has not contacted The Company to cancel the visit at least 24 hours prior to
                the start of the session, The Client agrees to pay the regular amount due for The
                Visit, regardless of whether the session was carried out or not.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="8. Termination"
            contents={
              <>
                {emphasis("8.1.")}The Client may terminate this contract by providing 30 days’ prior
                notice in writing once the initial contracted term (12 months) has ended.
                <br />
                {emphasis("8.2.")}If The Client wishes to terminate the contract within the initial
                contracted term (12 months), The Client must pay the outstanding balance for the
                remainder of the contract.
                <br />
                {emphasis("8.3.")}The Client agrees to pay a cancellation fee equivalent to the cost
                of 30 days of service if:
                <br />
                <MKBox sx={{ pl: 3 }} component="ol" color="text">
                  {emphasis("a)")}No notice is given;
                  <br />
                  {emphasis("b)")}The Client provides a termination notice of less than 30 days.
                </MKBox>
                {emphasis("8.4.")}Prior to termination of the contract, The Client is obliged to
                provide details of any incoming contractor for the purposes of compliance with the
                Transfer of Undertakings (Protection of Employment) Regulations 2003.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="9. Claims"
            contents={
              <>
                {emphasis("9.1.")}The Company’s public liability insurance will cover damages caused
                by The Service on behalf of The Company up to €1,000,000.00. To keep our prices
                competitive, all claims are subject to an excess of €100.00, payable by The Client.
                <br />
                {emphasis("9.2.")}The Client agrees that, due to the nature of The Service, The
                Company guarantees only to correct any problems reported within 24 hours. If a
                problem occurs on a Saturday, it must be reported by Monday at 12:00 to be accepted
                as a valid claim. Failure to do so will entitle The Client to no compensation. The
                Company may require entry to the location of the claim within 24 hours to correct
                the issue. Any refunds or adjustments must be requested directly to The Company and
                are subject to approval by The Company.
                <br />
                {emphasis("9.3.")}The Client waives the right to stop payment on their cheque unless
                The Company fails to make good on the guarantee shown in part 13.
                <br />
                {emphasis("9.4.")}While The Personnel make every effort not to break items,
                accidents do happen. Identical replacement is always attempted but not guaranteed.
                For this specific reason, The Company requests that all irreplaceable items (whether
                monetarily or sentimentally valuable) be stored away and/or not serviced by The
                Personnel.
                <br />
                {emphasis("9.5.")}In the case of damage, The Company will repair the item at its
                cost. If the item cannot be repaired, The Company will rectify the issue by
                crediting The Client with the item’s current actual cash value toward a like
                replacement from The Company’s source, upon payment of The Service rendered.
                <br />
                {emphasis("9.6.")}The Company shall not be responsible for damage due to faulty
                and/or improper installation of any item. All surfaces (i.e., marble, granite, etc.)
                are assumed sealed and ready to service without causing harm.
                <br />
                {emphasis("9.7.")}Any attempt to commit insurance fraud or use false information to
                commit any type of fraud will be prosecuted to the fullest extent of the law by The
                Company and the Insurance Provider(s). Monetary compensation, as well as legal fees,
                may be incurred.
                <br />
                {emphasis("9.8.")}Key replacement/locksmith fees are paid only if keys are lost by
                our Personnel. There is a €30 per location liability limit.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="10. Complaints"
            contents={
              <>
                {emphasis("10.1.")}All complaints are taken seriously. If The Client is not happy
                with any aspect of our Service, please call us as soon as possible and give us the
                chance to rectify it. Your satisfaction is very important to us, and we want you to
                be happy.
                <br />
                {emphasis("10.2.")}If The Client is dissatisfied with an ongoing service, The
                Company asks that The Client notify us as soon as they notice anything that might be
                to their dislike by email. Please do not wait until the service is ending.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="11. Liability"
            contents={
              <>
                {emphasis("11.1.")}he Company shall not be liable under any circumstances for any
                loss, expense, damage, delay, costs, or compensation (whether direct, indirect, or
                consequential) which may be suffered or incurred by The Client arising from or in
                any way connected with a late arrival of The Personnel at the service address. The
                Company endeavours to be on time for any visit, but sometimes, due to
                transport-related and other problems beyond The Company’s control, The Personnel may
                arrive with a delay or The Visit may be re-scheduled.
                <br />
                {emphasis("11.2.")}The Company shall not be liable under any circumstances for any
                loss, expense, damage, delay, costs, or compensation (whether direct, indirect, or
                consequential) which may be suffered or incurred by The Client arising from or in
                any way connected with:
                <br />
                <MKBox sx={{ pl: 3 }} component="ol" color="text">
                  {emphasis("a)")}A cleaning job not being completed due to the lack of hot water or
                  electricity;
                  <br />
                  {emphasis("b)")}Third parties entering or being present at The Client’s premises
                  during the cleaning process;
                  <br />
                  {emphasis("c)")}Any existing damage to The Client&apos;s property in the form of
                  old stains, burns, spillages, etc., which cleaned or removed completely by The
                  Personnel.
                </MKBox>
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="12. Supplementary Terms"
            contents={
              <>
                {emphasis("12.1.")}If The Client requests keys to be collected by The Company’s
                personnel from a third party’s address, a charge of €5.00 will apply. This charge
                covers only the collection of keys. If said keys need to be returned to the third
                party’s address or any other address, an additional charge of €5.00 will apply.
                <br />
                {emphasis("12.2.")}The Company reserves the right to re-evaluate rates at any time
                should The Client’s initial list of tasks change.
                <br />
                {emphasis("12.3.")}The Company reserves the right to amend the initial quotation
                should The Client’s original requirements change.
                <br />
                {emphasis("12.4.")}Any estimates of how long it will take The Personnel to complete
                the job are based on the average time required to service a property of similar size
                to The Client’s. It is difficult to precisely calculate how long such tasks may
                take, and a degree of flexibility may be required. Please note that one-off services
                may take longer to complete due to longer intervals between sessions and the
                number/type of tasks required, compared to regular maintenance of the same property.
                <br />
                {emphasis("12.5.")}The Client understands that the price quoted may vary depending
                on the condition of the property, room sizes, etc.
                <br />
                {emphasis("12.6.")}The Company shall endeavour to arrange replacement personnel if
                the regular personnel is unable to attend a scheduled visit, and will inform The
                Client prior to The Visit.
                <br />
                {emphasis("12.7.")}Post-construction cleaning (builders cleaning), event cleaning,
                or cleaning of badly neglected homes may take up to three times longer than cleaning
                a well-maintained home requiring general cleaning. Therefore, The Company advises
                The Client to inquire about our specialist cleaning services: Builders Cleaning or
                Event Cleaning.
                <br />
                {emphasis("12.8.")}The Personnel are not permitted to hand wash any clothing items
                belonging to The Client. The Company advises that The Personnel may only use a
                washing machine for such tasks.
                <br />
                {emphasis("12.9.")}All fragile and highly breakable items must be secured or removed
                prior to The Service.
                <br />
                {emphasis("12.10.")}The Company reserves the right to make reasonable changes to
                these Terms and Conditions in agreement with The Client.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="13. Our Guarantee"
            contents={
              <>
                {emphasis("13.1.")}The Company has built its business and reputation by providing
                the best possible service available. However, The Company recognises that, as The
                Personnel are human beings, mistakes can occasionally occur. For this reason, The
                Company offers a Guarantee. If The Client is not satisfied with any areas serviced
                by The Personnel, The Personnel will return to The Client’s premises and re-service
                those areas free of charge. Please note that this guarantee will not apply if the
                condition of the premises has deteriorated since the original service was performed,
                or if the original service was conducted by another company or individual.
              </>
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default TnC_Section1;
